import { render, staticRenderFns } from "./listForm.vue?vue&type=template&id=a2067f34&scoped=true&"
import script from "./listForm.vue?vue&type=script&lang=js&"
export * from "./listForm.vue?vue&type=script&lang=js&"
import style0 from "./listForm.vue?vue&type=style&index=0&id=a2067f34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2067f34",
  null
  
)

export default component.exports